import React from 'react';

const Error = (props) => {
    const {
        error = null
    } = props;

    if (!error || error === '') {
        return null;
    }

    return (
        <div className={'form-input-error'}>
            {error}
        </div>
    );
}

export default Error;
